require('./brokerProductFileTab.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { Component } = require('react');
const { getLanguage } = require('core/i18n').i18n;

class NewsTab extends Component {
    render() {
        const { isinCode } = this.props;
        const language = getLanguage() === 'es' ? 'es' : getLanguage();
        const iframeUrl = `https://openbank-analisis.webfg.com/noticias/${isinCode}/${language}`;
        return (
            <div className="broker-product-file-tab">
                <div id="broker-product-file-tab-news" className="broker-product-file-news">
                    <iframe
                        className="broker-product-file-tab__iframe"
                        src={iframeUrl} />
                </div>
            </div>
        );
    }
}

NewsTab.propTypes = {
    isinCode: PropTypes.string
}

module.exports = NewsTab;
